.help-tip-container{font-weight:400;font-style:italic;letter-spacing:0;opacity:1;display:flex;flex-direction:column;gap:5px}.title{font-weight:400;font-style:normal;padding-bottom:3px}
/*# sourceMappingURL=help-tip.component-SPNIPKNV.css.map */
